module.exports = __webpack_public_path__ + "files/b34820a6c22107762018456963085c20.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/smileys_emotion-2.png
// module id = 493
// module chunks = 76